import React from 'react';
import c from 'classnames';
import NoAI from '@wix/da-ds/pkg/Indicators/NoAI';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import { useTranslation } from 'react-i18next';

import s from './NoAIWithTooltip.scss';

export interface Props {
  className?: string;
}

export const NoAIWithTooltip: React.FC<React.PropsWithChildren<Props>> = ({
  className,
}) => {
  const { t } = useTranslation();
  return (
    <SophisticatedTooltip
      className={c(s['root'], className)}
      size="medium"
      aria-label={t('noAIWithTooltip.noai')}
      description={t('noAIWithTooltip.tooltip')}
      hasCloseButton={false}
      postfix={
        <SophisticatedTooltipLink href={t('noAIWithTooltip.readMore.url')}>
          {t('noAIWithTooltip.readMore')}
        </SophisticatedTooltipLink>
      }
    >
      <NoAI className={s['icon']} /> {t('noAIWithTooltip.noai')}
    </SophisticatedTooltip>
  );
};
NoAIWithTooltip.displayName = 'NoAIWithTooltip';

export default NoAIWithTooltip;
